// Helper global (fuera del IIFE de abajo a propósito: lo usan store-pickup.js,
// event-buy.js y cart-page.js, cargados después de este archivo). Existe porque
// /cart/update.js con `attributes` REEMPLAZA todo cart.attributes, no lo fusiona
// — cada flujo que llamaba a ese endpoint con solo sus propias keys (factura,
// boleta_rut, Canal/Evento, preferred_pickup_*) se pisaba en silencio con
// cualquiera de los otros que corriera después en la misma sesión de carrito
// (2026-09-17, bug real: el RUT no llegaba al pedido). Siempre leer el estado
// actual del carrito antes de escribir, nunca asumirlo.
window.BenisCart = window.BenisCart || {};
window.BenisCart.updateAttributes = async function updateAttributes(partial) {
  const current = await fetch('/cart.js').then((res) => res.json());
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { ...current.attributes, ...partial } }),
  });
};

(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // "Vuela al carrito" — al agregar un producto, una miniatura de su foto viaja
  // en arco desde el botón que se tocó hasta el ícono del carrito del header
  // (mismo efecto que tenía el sitio anterior). Puramente decorativo: nunca
  // bloquea ni espera al fetch real de /cart/add.js, solo corre en paralelo.
  // Respeta prefers-reduced-motion (no anima, el agregado real sigue igual).
  function flyToCart(imageUrl, sourceEl) {
    if (reducedMotion.matches || !imageUrl || !sourceEl) return;
    const destination = document.querySelector('[data-cart-open]');
    if (!destination) return;

    const el = document.createElement('div');
    el.className = 'fly-to-cart';
    el.style.backgroundImage = `url(${imageUrl})`;
    document.body.appendChild(el);

    const size = el.getBoundingClientRect();
    const sourceRect = sourceEl.getBoundingClientRect();
    const destRect = destination.getBoundingClientRect();
    const offsetX = size.width / 2;
    const offsetY = size.height / 2;
    const start = { x: sourceRect.left + sourceRect.width / 2 - offsetX, y: sourceRect.top + sourceRect.height / 2 - offsetY };
    const end = { x: destRect.left + destRect.width / 2 - offsetX, y: destRect.top + destRect.height / 2 - offsetY };
    // Puntos de control curvados hacia arriba — el mismo criterio que un tiro
    // parabólico, para que no vuele en línea recta.
    const c1 = { x: start.x, y: start.y - 200 };
    const c2 = { x: end.x - 200, y: end.y - 100 };

    function bezierPoint(t, p0, p1, p2, p3) {
      const cX = 3 * (p1.x - p0.x);
      const bX = 3 * (p2.x - p1.x) - cX;
      const aX = p3.x - p0.x - cX - bX;
      const cY = 3 * (p1.y - p0.y);
      const bY = 3 * (p2.y - p1.y) - cY;
      const aY = p3.y - p0.y - cY - bY;
      return {
        x: aX * t ** 3 + bX * t ** 2 + cX * t + p0.x,
        y: aY * t ** 3 + bY * t ** 2 + cY * t + p0.y,
      };
    }

    el.style.setProperty('--x', `${start.x}px`);
    el.style.setProperty('--y', `${start.y}px`);
    el.style.opacity = '1';

    const duration = 600;
    let startTime = null;
    function step(time) {
      if (startTime === null) startTime = time;
      const progress = Math.min((time - startTime) / duration, 1);
      const pos = bezierPoint(progress, start, c1, c2, end);
      el.style.setProperty('--x', `${pos.x}px`);
      el.style.setProperty('--y', `${pos.y}px`);
      el.style.setProperty('--scale', `${1 - progress * 0.5}`);
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.style.opacity = '0';
        window.setTimeout(() => el.remove(), 300);
      }
    }
    requestAnimationFrame(step);
  }

  // Busca la imagen más relacionada con el botón que se tocó, para flyToCart —
  // la del product-card/upsell-card más cercano, o si no hay ninguno (botón
  // principal del PDP) la primera foto de la galería del producto.
  function resolveFlyImage(sourceEl) {
    const card = sourceEl.closest('.product-card, .cart-upsell-card');
    const cardImg = card?.querySelector('img');
    if (cardImg) return cardImg.currentSrc || cardImg.src;
    const galleryImg = document.querySelector('#pdpGallery img');
    return galleryImg ? galleryImg.currentSrc || galleryImg.src : null;
  }

  function initMobileMenu() {
    const button = document.querySelector('[data-mobile-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!button || !menu || button.dataset.initialized === 'true') return;

    button.dataset.initialized = 'true';
    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
    });

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        button.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
      });
    });
  }

  function initBottomBrandBanner() {
    const banner = document.getElementById('bottomBrandBanner');
    if (!banner || banner.dataset.initialized === 'true') return;
    banner.dataset.initialized = 'true';

    const footer = document.querySelector('.site-footer');
    if (!footer) return;

    const observer = new IntersectionObserver(
      ([entry]) => { banner.classList.toggle('is-hidden', entry.isIntersecting); },
      { threshold: 0 }
    );
    observer.observe(footer);
  }

  /* ===== CART DRAWER ===== */

  function updateCartCountBadges(count) {
    document.querySelectorAll('[data-cart-count], [data-cart-count-mobile]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // The whole drawer is swapped wholesale on every cart change (see fetch below),
  // so a plain CSS `transition` on the shipping bar never has anything to animate
  // FROM — it's a fresh element at its final width the instant it lands in the DOM.
  // Capture the outgoing bar/puck position first, then after the swap momentarily
  // pin the new ones back to that old position and let them transition forward —
  // same trick as a FLIP animation.
  // Escopado a .cart-drawer__inner a propósito: snippets/free-shipping-progress.liquid
  // ahora también se renderiza en sections/main-cart.liquid (/cart), así que puede
  // haber un segundo [data-shipping-fill]/[data-shipping-puck] en la misma página —
  // un querySelector global tomaría el primero que encuentre en el documento, sin
  // garantía de que sea el del drawer.
  function captureShippingProgress() {
    const fill = document.querySelector('.cart-drawer__inner [data-shipping-fill]');
    const puck = document.querySelector('.cart-drawer__inner [data-shipping-puck]');
    if (!fill) return null;
    return { fillWidth: fill.style.width, puckLeft: puck ? puck.style.left : null };
  }

  function animateShippingProgress(prev) {
    if (!prev) return;
    const fill = document.querySelector('.cart-drawer__inner [data-shipping-fill]');
    const puck = document.querySelector('.cart-drawer__inner [data-shipping-puck]');
    if (!fill) return;

    const targetWidth = fill.style.width;
    const targetLeft = puck ? puck.style.left : null;

    fill.style.transition = 'none';
    fill.style.width = prev.fillWidth;
    if (puck) {
      puck.style.transition = 'none';
      puck.style.left = prev.puckLeft;
    }

    void fill.offsetWidth; // force reflow so the browser commits the "old" position first

    fill.style.transition = '';
    fill.style.width = targetWidth;
    if (puck) {
      puck.style.transition = '';
      puck.style.left = targetLeft;
    }
  }

  async function refreshCartDrawer(depth = 0, checkRemoval = true) {
    const inner = document.querySelector('.cart-drawer__inner');
    if (!inner) return;

    inner.style.opacity = '0.5';
    inner.style.pointerEvents = 'none';

    const prevShippingProgress = captureShippingProgress();

    try {
      const res = await fetch('/?sections=header');
      const data = await res.json();

      const parser = new DOMParser();
      const doc = parser.parseFromString(data.header, 'text/html');
      const newInner = doc.querySelector('.cart-drawer__inner');
      const countEl = doc.querySelector('[data-cart-count]');

      if (newInner) inner.innerHTML = newInner.innerHTML;

      const count = countEl ? parseInt(countEl.textContent || '0', 10) : 0;
      updateCartCountBadges(count);

      // re-attach countdown after DOM swap
      startDeliveryCountdown();
      formatPrices();
      animateShippingProgress(prevShippingProgress);
      await enforceGadgetInvariants(depth, checkRemoval);

    } catch (err) {
      console.error('Cart refresh error:', err);
    } finally {
      inner.style.opacity = '';
      inner.style.pointerEvents = '';
    }
  }

  // The free-shipping "gadget" upsell only makes sense while the rest of the cart
  // still justifies it (see snippets/cart-drawer.liquid) and must stay at qty 1 —
  // otherwise it's a free $1.000-off bottle with no order backing the discount.
  // Liquid computes the verdict server-side on every render; this just executes it.
  // checkRemoval is only true after a decrease/remove action (or on initial load, to
  // clean up any stale state) — adding more items should never yank an already-earned
  // gadget away just because the rest of the cart alone now clears the threshold.
  async function enforceGadgetInvariants(depth = 0, checkRemoval = true) {
    if (depth >= 2) return; // one correction pass is enough; guards against any loop
    const footer = document.getElementById('cartDrawerFooter');
    if (!footer) return;

    const gadgetKey = footer.dataset.gadgetKey;
    const needsRemoval = checkRemoval && footer.dataset.gadgetNeedsRemoval === 'true';
    const needsQtyFix = footer.dataset.gadgetNeedsQtyFix === 'true';
    if (!gadgetKey || (!needsRemoval && !needsQtyFix)) return;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: gadgetKey, quantity: needsRemoval ? 0 : 1 }),
    });
    await refreshCartDrawer(depth + 1, true);
  }

  async function changeCartItem(key, quantity, checkRemoval = true) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    await refreshCartDrawer(0, checkRemoval);
  }

  function startDeliveryCountdown() {
    const timer = document.getElementById('cartDeliveryTimer');
    if (!timer) return;

    function tick() {
      const now = new Date();
      const cutoff = new Date();
      const deliveryBox = timer.closest('.cart-drawer__delivery');
      const cutoffHour = Number.parseInt(deliveryBox?.dataset.cutoffHour || '12', 10);
      cutoff.setHours(Number.isFinite(cutoffHour) ? cutoffHour : 12, 0, 0, 0);
      if (now >= cutoff) { timer.closest('.cart-drawer__delivery')?.remove(); return; }
      const diff = cutoff - now;
      const h = String(Math.floor(diff / 3600000)).padStart(2, '0');
      const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      timer.textContent = `${h}:${m}:${s}`;
    }
    tick();
    setInterval(tick, 1000);
  }

  function openCartDrawer() {
    const drawer = document.getElementById('cartDrawer');
    if (!drawer) return;
    drawer.showModal();
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    const drawer = document.getElementById('cartDrawer');
    if (!drawer) return;
    drawer.close();
    document.body.style.overflow = '';
  }

  function initCartDrawer() {
    const drawer = document.getElementById('cartDrawer');
    if (!drawer || drawer.dataset.initialized === 'true') return;
    drawer.dataset.initialized = 'true';

    // close button — delegated so it survives innerHTML swaps in refreshCartDrawer
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-close]')) closeCartDrawer();
    });

    // click on backdrop (outside dialog)
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) closeCartDrawer();
    });

    // Escape key is handled natively by <dialog>
    drawer.addEventListener('close', () => { document.body.style.overflow = ''; });

    // open triggers (header desktop + mobile)
    document.querySelectorAll('[data-cart-open]').forEach((btn) => {
      btn.addEventListener('click', openCartDrawer);
    });

    // quantity + remove buttons (delegated, works after Section Rendering updates)
    drawer.addEventListener('click', async (e) => {
      const qtyBtn = e.target.closest('[data-qty-decrease], [data-qty-increase]');
      const removeBtn = e.target.closest('[data-qty="0"]');

      if (qtyBtn || removeBtn) {
        const btn = qtyBtn || removeBtn;
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        if (!key) return;
        const isDecreaseOrRemove = !!(e.target.closest('[data-qty-decrease]') || removeBtn);
        await changeCartItem(key, qty, isDecreaseOrRemove);
      }
    });

    // Cart upsell products
    drawer.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-upsell-add]');
      if (!btn || btn.disabled) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const label = btn.querySelector('[data-cart-upsell-label]');
      const original = label ? label.textContent : btn.textContent;

      flyToCart(resolveFlyImage(btn), btn);

      btn.disabled = true;
      if (label) label.textContent = 'Agregando…';
      else btn.textContent = 'Agregando…';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        btn.classList.add('is-added');
        if (label) label.textContent = 'Agregado ✓';
        else btn.textContent = 'Agregado ✓';

        await refreshCartDrawer(0, false); // adding items never triggers gadget removal
      } catch (err) {
        console.error('Cart upsell ATC error:', err);
        btn.disabled = false;
        if (label) label.textContent = original;
        else btn.textContent = original;
      }
    });

    startDeliveryCountdown();
    enforceGadgetInvariants();
  }

  /* ===== SEARCH MODAL ===== */
  function initSearchModal() {
    const modal = document.getElementById('searchModal');
    if (!modal || modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    function openSearch() {
      modal.showModal();
      document.body.style.overflow = 'hidden';
      setTimeout(() => modal.querySelector('#searchModalInput')?.focus(), 50);
    }

    function closeSearch() {
      modal.close();
      document.body.style.overflow = '';
    }

    modal.querySelector('[data-search-close]')?.addEventListener('click', closeSearch);
    modal.addEventListener('close', () => { document.body.style.overflow = ''; });
    modal.addEventListener('click', (e) => { if (e.target === modal) closeSearch(); });

    document.querySelectorAll('[data-search-open]').forEach((btn) => {
      btn.addEventListener('click', openSearch);
    });
  }

  /* ===== PDP ===== */
  function initPDP() {
    if (!document.getElementById('pdpGallery')) return;

    // Cantidad
    const qtyMinus = document.getElementById('pdpQtyMinus');
    const qtyPlus  = document.getElementById('pdpQtyPlus');
    const qtyValue = document.getElementById('pdpQtyValue');
    const qtyInput = document.getElementById('pdpQtyInput');
    let qty = 1;

    qtyMinus?.addEventListener('click', () => {
      qty = Math.max(1, qty - 1);
      qtyValue.textContent = String(qty);
      if (qtyInput) qtyInput.value = qty;
    });

    qtyPlus?.addEventListener('click', () => {
      qty += 1;
      qtyValue.textContent = String(qty);
      if (qtyInput) qtyInput.value = qty;
    });

    // ATC con AJAX
    const form = document.getElementById('pdpForm');
    const addBtn = document.getElementById('pdpAddBtn');

    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!addBtn || addBtn.disabled) return;

      const variantId = document.getElementById('pdpVariantId')?.value;
      if (!variantId) return;

      flyToCart(resolveFlyImage(addBtn), addBtn);

      addBtn.disabled = true;
      const original = addBtn.textContent;
      addBtn.textContent = 'Agregando…';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty }),
        });

        addBtn.textContent = 'Agregado ✓';
        addBtn.classList.add('is-added');

        await refreshCartDrawer();
        openCartDrawer();

        window.setTimeout(() => {
          addBtn.textContent = original;
          addBtn.classList.remove('is-added');
          addBtn.disabled = false;
        }, 1600);
      } catch (err) {
        console.error('ATC error:', err);
        addBtn.textContent = original;
        addBtn.disabled = false;
      }
    });

    // Lightbox de galería
    const cells = [...document.querySelectorAll('#pdpGallery .pdp-gallery-cell')];
    const lightbox = document.getElementById('pdpLightbox');
    const track    = document.getElementById('pdpLightboxTrack');
    const dots     = [...document.querySelectorAll('#pdpLightboxDots .pdp-lightbox-dot')];
    const prev     = document.getElementById('pdpLightboxPrev');
    const next     = document.getElementById('pdpLightboxNext');
    const close    = document.getElementById('pdpLightboxClose');
    let current    = 0;
    const total    = cells.length;

    if (!lightbox || total === 0) return;

    function goTo(index) {
      current = (index + total) % total;
      track.style.transform = `translateX(${-current * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    function openLightbox(index) {
      goTo(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    cells.forEach((cell, i) => cell.addEventListener('click', () => openLightbox(i)));
    close?.addEventListener('click', closeLightbox);
    prev?.addEventListener('click', () => goTo(current - 1));
    next?.addEventListener('click', () => goTo(current + 1));
    dots.forEach((d) => d.addEventListener('click', () => goTo(Number(d.dataset.index))));
    lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Swipe en lightbox
    let dragStartX = 0;
    let dragging = false;
    const stage = document.getElementById('pdpLightboxStage');

    stage?.addEventListener('pointerdown', (e) => {
      dragging = true;
      dragStartX = e.clientX;
      track.style.transition = 'none';
    });

    stage?.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const pct = ((e.clientX - dragStartX) / stage.clientWidth) * 100;
      track.style.transform = `translateX(${-current * 100 + pct}%)`;
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      const delta = e.clientX - dragStartX;
      if (delta < -60) goTo(current + 1);
      else if (delta > 60) goTo(current - 1);
      else goTo(current);
    }

    stage?.addEventListener('pointerup', endDrag);
    stage?.addEventListener('pointerleave', endDrag);
  }

  /* ===== COMPRADOS JUNTOS FRECUENTEMENTE (PDP) ===== */
  function initFbt() {
    const wrap = document.getElementById('pdpFbt');
    if (!wrap) return;

    const checkboxes = [...wrap.querySelectorAll('[data-fbt-checkbox]')];
    const totalEl = document.getElementById('pdpFbtTotal');
    const addBtn = document.getElementById('pdpFbtAddBtn');
    const basePrice = Number(totalEl?.dataset.basePrice || 0);
    const mainVariantId = addBtn?.dataset.mainVariantId;

    function formatMoney(cents) {
      const amount = (cents / 100).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return `$${amount}`;
    }

    function updateTotal() {
      let total = basePrice;
      checkboxes.forEach((cb) => {
        if (cb.checked) total += Number(cb.dataset.price || 0);
      });
      if (totalEl) totalEl.textContent = formatMoney(total);
    }

    checkboxes.forEach((cb) => cb.addEventListener('change', updateTotal));
    updateTotal();

    addBtn?.addEventListener('click', async () => {
      if (!mainVariantId || addBtn.disabled) return;

      const items = [{ id: Number(mainVariantId), quantity: 1 }];
      checkboxes.forEach((cb) => {
        if (cb.checked) items.push({ id: Number(cb.dataset.variantId), quantity: 1 });
      });

      flyToCart(resolveFlyImage(addBtn), addBtn);

      addBtn.disabled = true;
      const original = addBtn.textContent;
      addBtn.textContent = 'Agregando…';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });

        addBtn.textContent = 'Agregado ✓';
        await refreshCartDrawer();
        openCartDrawer();

        window.setTimeout(() => {
          addBtn.textContent = original;
          addBtn.disabled = false;
        }, 1600);
      } catch (err) {
        console.error('FBT ATC error:', err);
        addBtn.textContent = original;
        addBtn.disabled = false;
      }
    });
  }

  /* ===== BOX INFERIOR CON PESTAÑAS (PDP): "También te puede interesar" / "Calificaciones" ===== */
  function initPdpBottomTabs() {
    const wrap = document.getElementById('pdpBottomTabs');
    if (!wrap) return;

    const buttons = [...wrap.querySelectorAll('[data-tab-btn]')];
    const panels = [...wrap.querySelectorAll('[data-tab-panel]')];

    function activateTab(name, { scroll = false } = {}) {
      buttons.forEach((btn) => {
        const active = btn.dataset.tabBtn === name;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== name;
      });
      if (scroll) {
        wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => activateTab(btn.dataset.tabBtn));
    });

    // El badge "5.0 · N reseñas" de arriba del PDP apunta a #pdpReviews, que
    // vive dentro de la pestaña "Calificaciones" — hay que activarla antes de
    // que el navegador intente hacer scroll, si no el target sigue oculto.
    document.querySelectorAll('a.pdp-rating[href="#pdpReviews"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        activateTab('reviews', { scroll: true });
      });
    });

    if (window.location.hash === '#pdpReviews') {
      activateTab('reviews', { scroll: true });
    }
  }

  /* ===== ESCRIBE TU RESEÑA (PDP) ===== */
  function initReviewForm() {
    const wrap = document.getElementById('pdpReviewForm');
    if (!wrap) return;

    const form = document.getElementById('pdpReviewFormFields');
    const stars = [...wrap.querySelectorAll('[data-star]')];
    const ratingInput = document.getElementById('pdpReviewRating');
    const submitBtn = document.getElementById('pdpReviewSubmit');
    const errorEl = document.getElementById('pdpReviewError');
    const successEl = document.getElementById('pdpReviewSuccess');
    const proxyUrl = wrap.dataset.reviewProxyUrl;
    // Con selector de producto (página "Todas las reseñas", sin un product
    // de contexto fijo) el id sale del <select>; en el PDP sigue viniendo
    // del data-product-id fijo de siempre.
    const productSelect = document.getElementById('pdpReviewProduct');

    // Foto opcional — se manda como base64 al Worker, que la sube a Shopify
    // Files y recién ahí le pasa la URL a Judge.me (ver cloudflare-review-proxy).
    const photoInput = document.getElementById('pdpReviewPhoto');
    const photoNameEl = document.getElementById('pdpReviewPhotoName');
    const photoRemoveBtn = document.getElementById('pdpReviewPhotoRemove');
    const photoPreviewEl = document.getElementById('pdpReviewPhotoPreview');
    const MAX_PHOTO_BYTES = 10 * 1024 * 1024;
    const ALLOWED_PHOTO_TYPES = ['image/jpeg', 'image/png'];

    function resetPhotoField() {
      photoInput.value = '';
      photoNameEl.textContent = 'Ningún archivo elegido';
      photoRemoveBtn.hidden = true;
      photoPreviewEl.hidden = true;
      if (photoPreviewEl.src) URL.revokeObjectURL(photoPreviewEl.src);
      photoPreviewEl.removeAttribute('src');
    }

    photoInput?.addEventListener('change', () => {
      const file = photoInput.files[0];
      if (!file) {
        resetPhotoField();
        return;
      }
      if (!ALLOWED_PHOTO_TYPES.includes(file.type) || file.size > MAX_PHOTO_BYTES) {
        showError('La foto debe ser JPG o PNG de hasta 10 MB.');
        resetPhotoField();
        return;
      }
      photoNameEl.textContent = file.name;
      photoRemoveBtn.hidden = false;
      photoPreviewEl.src = URL.createObjectURL(file);
      photoPreviewEl.hidden = false;
    });

    photoRemoveBtn?.addEventListener('click', resetPhotoField);

    function fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(',')[1] || '');
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    }

    function setRating(value) {
      ratingInput.value = value;
      stars.forEach((star) => {
        const active = Number(star.dataset.star) <= value;
        star.classList.toggle('is-active', active);
        star.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    stars.forEach((star) => {
      star.addEventListener('click', () => setRating(Number(star.dataset.star)));
    });

    function showError(message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      successEl.hidden = true;
    }

    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.hidden = true;
      successEl.hidden = true;

      const productId = productSelect ? productSelect.value : wrap.dataset.productId;
      const rating = Number(ratingInput.value);
      const name = form.name.value.trim();
      const email = form.email.value.trim();
      const title = form.title.value.trim();
      const body = form.body.value.trim();
      const website = form.website.value; // honeypot

      if (productSelect && !productId) {
        showError('Selecciona qué producto probaste.');
        return;
      }
      if (!rating) {
        showError('Selecciona una calificación de 1 a 5 estrellas.');
        return;
      }
      if (!name || !email || body.length < 8) {
        showError('Completa tu nombre, email y una reseña de al menos 8 caracteres.');
        return;
      }

      const photoFile = photoInput?.files[0] || null;
      if (photoFile && (!ALLOWED_PHOTO_TYPES.includes(photoFile.type) || photoFile.size > MAX_PHOTO_BYTES)) {
        showError('La foto debe ser JPG o PNG de hasta 10 MB.');
        return;
      }

      submitBtn.disabled = true;
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Enviando…';

      try {
        let photo;
        if (photoFile) {
          photo = { data: await fileToBase64(photoFile), mime_type: photoFile.type, filename: photoFile.name };
        }

        const res = await fetch(proxyUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            product_id: productId,
            rating,
            name,
            email,
            title,
            body,
            website,
            photo,
          }),
        });

        const data = await res.json().catch(() => ({}));

        if (!res.ok || !data.ok) {
          showError('No pudimos enviar tu reseña. Intenta de nuevo en unos minutos.');
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
          return;
        }

        successEl.hidden = false;
        form.reset();
        setRating(0);
        resetPhotoField();
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      } catch (err) {
        console.error('Review submit error:', err);
        showError('No pudimos enviar tu reseña. Revisa tu conexión e intenta de nuevo.');
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    });
  }

  /* ===== DRAWER DE FILTROS (colección + PDP) ===== */
  function initFilterDrawer() {
    const fab = document.getElementById('collectionFilterFab');
    const drawer = document.getElementById('collectionFilterDrawer');
    const drawerClose = document.getElementById('collectionFilterDrawerClose');
    if (!fab || !drawer) return;

    function openFilterDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      fab.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeFilterDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      fab.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    // En el PDP, inyectar filtros desde la colección vía fetch
    const isProductPage = !!document.getElementById('pdpGallery');
    let filtersLoaded = false;

    async function loadFiltersFromCollection() {
      if (filtersLoaded) return;
      const panel = drawer.querySelector('.collection-filter-drawer__panel');
      const hint = drawer.querySelector('.collection-filter-drawer__hint');
      const shopLink = drawer.querySelector('.collection-filter-drawer__shop-link');

      try {
        const res = await fetch('/collections/all?sections=main-collection');
        const data = await res.json();
        const parser = new DOMParser();
        const doc = parser.parseFromString(data['main-collection'], 'text/html');
        const filters = doc.querySelectorAll('.collection-filters .collection-filter');

        if (filters.length > 0) {
          // Crear form que envía a la colección
          const newForm = document.createElement('form');
          newForm.className = 'collection-filter-drawer__form';
          newForm.action = '/collections/all';
          newForm.method = 'get';
          filters.forEach(f => newForm.appendChild(f.cloneNode(true)));

          hint?.remove();
          shopLink?.remove();
          panel.appendChild(newForm);

          // Auto-submit checkboxes inyectados
          newForm.querySelectorAll('[data-filter-auto-submit]').forEach((cb) => {
            cb.addEventListener('change', () => newForm.submit());
          });

          filtersLoaded = true;
        }
      } catch (e) {
        console.error('Error cargando filtros:', e);
      }
    }

    fab.addEventListener('click', () => {
      if (isProductPage) loadFiltersFromCollection();
      openFilterDrawer();
    });
    drawerClose?.addEventListener('click', closeFilterDrawer);

    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) closeFilterDrawer();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeFilterDrawer();
    });

    drawer.querySelectorAll('[data-filter-auto-submit]').forEach((cb) => {
      cb.addEventListener('change', () => cb.closest('form')?.submit());
    });
  }

  /* ===== COLECCIÓN ===== */
  function initCollection() {
    if (!document.querySelector('.collection-page')) return;

    // Auto-submit checkboxes de filtro
    document.querySelectorAll('[data-filter-auto-submit]').forEach((cb) => {
      cb.addEventListener('change', () => {
        cb.closest('form')?.submit();
      });
    });

    // Sort → redirect
    document.querySelector('[data-collection-sort]')?.addEventListener('change', (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    });

    // Filtro de Categoría — 100% client-side (ver comentario en main-collection.liquid)
    (function initCategoryFilter() {
      const checkboxes = [...document.querySelectorAll('[data-category-filter]')];
      const grid = document.querySelector('[data-collection-grid]');
      if (!checkboxes.length || !grid) return;

      const cards = [...grid.querySelectorAll('.collection-product-card')];
      const countEl = document.querySelector('[data-collection-count]');
      const emptyEl = document.querySelector('[data-collection-empty-category]');
      const clearBtn = document.querySelector('[data-category-clear]');

      function activeCategories() {
        return checkboxes.filter((cb) => cb.checked).map((cb) => cb.value);
      }

      function applyFilter() {
        const active = activeCategories();
        let visibleCount = 0;

        cards.forEach((card) => {
          const type = card.dataset.productType || '';
          const visible = active.length === 0 || active.includes(type);
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        if (countEl) {
          countEl.textContent = visibleCount === 1 ? '1 producto' : `${visibleCount} productos`;
        }

        if (emptyEl) {
          emptyEl.hidden = visibleCount !== 0;
        }
      }

      function syncUrl() {
        const active = activeCategories();
        const url = new URL(window.location.href);
        if (active.length) {
          url.searchParams.set('categoria', active.join(','));
        } else {
          url.searchParams.delete('categoria');
        }
        history.replaceState({}, '', url);
      }

      function setInitialStateFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const categoria = params.get('categoria');
        if (!categoria) return;
        const values = categoria.split(',');
        checkboxes.forEach((cb) => {
          if (values.includes(cb.value)) cb.checked = true;
        });
      }

      checkboxes.forEach((cb) => {
        cb.addEventListener('change', () => {
          applyFilter();
          syncUrl();
        });
      });

      clearBtn?.addEventListener('click', () => {
        checkboxes.forEach((cb) => { cb.checked = false; });
        applyFilter();
        syncUrl();
      });

      setInitialStateFromUrl();
      applyFilter();
    })();

    // Mini galería de fotos por card: hover muestra la 2ª foto, flechas navegan todas
    document.querySelectorAll('.collection-product-card__media[data-gallery]').forEach((media) => {
      const imgs = [...media.querySelectorAll('.collection-product-card__img')];
      const dots = [...media.querySelectorAll('.collection-product-card__dot')];
      if (imgs.length <= 1) return;

      let index = 0;

      function show(next) {
        index = (next + imgs.length) % imgs.length;
        imgs.forEach((img) => {
          img.style.opacity = Number(img.dataset.index) === index ? '1' : '0';
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
        });
      }

      media.addEventListener('mouseenter', () => {
        if (index === 0) show(1);
      });
      media.addEventListener('mouseleave', () => show(0));

      media.querySelector('[data-gallery-prev]')?.addEventListener('click', (e) => {
        e.preventDefault();
        show(index - 1);
      });
      media.querySelector('[data-gallery-next]')?.addEventListener('click', (e) => {
        e.preventDefault();
        show(index + 1);
      });
    });

    // Toggle sidebar móvil
    const toggleBtn = document.querySelector('[data-filter-toggle]');
    const sidebar = document.getElementById('collectionSidebar');

    toggleBtn?.addEventListener('click', () => {
      const isOpen = sidebar.classList.toggle('is-open');
      toggleBtn.setAttribute('aria-expanded', String(isOpen));
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Cerrar sidebar al hacer click fuera
    document.addEventListener('click', (e) => {
      if (
        sidebar?.classList.contains('is-open') &&
        !sidebar.contains(e.target) &&
        !toggleBtn?.contains(e.target)
      ) {
        sidebar.classList.remove('is-open');
        toggleBtn?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  // Agregar-al-carrito genérico: cualquier botón con [data-atc][data-variant-id]
  // en cualquier parte del sitio (colección, home, "también te puede interesar"
  // en PDP, las secciones de la página "Quiénes somos", y cualquier uso
  // futuro), sin importar la clase que use para su propio diseño. Un solo
  // listener delegado en document en vez de uno por sección: cubre también
  // botones que se inyectan después vía fetch (product-recommendations.liquid),
  // que con los listeners anteriores (atados por sección al cargar la página)
  // nunca quedaban con su botón funcionando.
  function initProductCardAtc() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-atc][data-variant-id]');
      if (!btn || btn.disabled) return;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      flyToCart(resolveFlyImage(btn), btn);

      btn.disabled = true;
      btn.classList.add('is-added');

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        await refreshCartDrawer();
        openCartDrawer();
      } catch (err) {
        console.error('Product card ATC error:', err);
      }

      window.setTimeout(() => {
        btn.disabled = false;
        btn.classList.remove('is-added');
      }, 1600);
    });
  }

  /* ===== FORMATO DE PRECIOS (CLP: $24.990 sin decimales) ===== */
  function formatPrices() {
    document.querySelectorAll('.money').forEach((el) => {
      // Remover .00 o ,00 al final y cambiar separador de miles , → .
      el.textContent = el.textContent
        .replace(/[.,]00$/, '')           // quita decimales cero
        .replace(/,(\d{3})/g, '.$1');     // coma de miles → punto
    });
  }

  function initAuthForms() {
    document.querySelectorAll('[data-pw-toggle]').forEach((btn) => {
      const wrap = btn.closest('.auth-input-wrap');
      if (!wrap) return;
      const input = wrap.querySelector('.auth-input');
      const eyeShow = btn.querySelector('.auth-eye--show');
      const eyeHide = btn.querySelector('.auth-eye--hide');
      btn.addEventListener('click', () => {
        const isPassword = input.type === 'password';
        input.type = isPassword ? 'text' : 'password';
        eyeShow.hidden = isPassword;
        eyeHide.hidden = !isPassword;
      });
    });
  }

  // Animaciones de entrada al hacer scroll: cualquier elemento con
  // data-reveal="left|right|up" se anima una sola vez la primera vez que
  // entra en el viewport (ver reglas [data-reveal] en theme.css).
  function initScrollReveal() {
    const els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -80px 0px' }
    );

    els.forEach((el) => observer.observe(el));
  }

  function initProductRecommendations() {
    const container = document.querySelector('#product-recommendations[data-url]');
    if (!container || container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    container.addEventListener('click', (e) => {
      const track = container.querySelector('[data-recs-track]');
      if (!track) return;
      const card = track.querySelector('.collection-product-card');
      const step = card ? card.getBoundingClientRect().width + 24 : 300;

      if (e.target.closest('[data-recs-next]')) track.scrollBy({ left: step, behavior: 'smooth' });
      if (e.target.closest('[data-recs-prev]')) track.scrollBy({ left: -step, behavior: 'smooth' });
    });

    fetch(container.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const recommendations = doc.querySelector('#product-recommendations');
        if (recommendations && recommendations.innerHTML.trim()) {
          container.innerHTML = recommendations.innerHTML;
          formatPrices();
        }
      })
      .catch((err) => console.error('Product recommendations error:', err));
  }

  // Empuja el mismo evento que usa el widget flotante de VentaPlay
  // (dataLayer.push con generate_lead / method: WhatsApp) para que CUALQUIER
  // apertura de WhatsApp del sitio quede unificada en analytics, aunque no
  // pase por su burbuja (Shadow DOM cerrado = no se puede disparar desde
  // afuera, así que replicamos el evento en vez de invocar su botón).
  function pushVentaPlayLeadEvent(widgetName) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'generate_lead',
        method: 'WhatsApp',
        widget: widgetName || 'whatsapp-inline',
      });
    } catch (e) { /* silent */ }
  }

  // Lets a visitor type their own message before WhatsApp opens, instead of
  // always sending the same pre-loaded text. Works for both a standalone
  // <form data-whatsapp-form> (submit-to-open) and a <div data-whatsapp-form>
  // wrapping a plain button[data-whatsapp-submit] when it lives inside another
  // <form> that we must not accidentally submit (e.g. the B2B contact form).
  function initWhatsappForms() {
    document.querySelectorAll('[data-whatsapp-form]').forEach((container) => {
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';

      const open = () => {
        const number = container.dataset.whatsappNumber;
        if (!number) return;
        const input = container.querySelector('input[name="message"]');
        const defaultMessage = container.dataset.whatsappDefault || '';
        const text = (input?.value || '').trim() || defaultMessage;
        const url = `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
        pushVentaPlayLeadEvent('whatsapp-form');
        window.open(url, '_blank', 'noopener,noreferrer');
      };

      if (container.tagName === 'FORM') {
        container.addEventListener('submit', (e) => {
          e.preventDefault();
          open();
        });
      } else {
        container.querySelector('[data-whatsapp-submit]')?.addEventListener('click', open);
      }
    });
  }

  // Cubre cualquier link directo a wa.me que exista o se agregue a futuro
  // (hoy: "Contacto" del header desktop y mobile) sin tener que instrumentar
  // cada uno a mano — delegado en document, se registra una sola vez.
  function initWhatsappLinkTracking() {
    if (document.body.dataset.whatsappTrackInit === 'true') return;
    document.body.dataset.whatsappTrackInit = 'true';
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href*="wa.me/"]');
      if (link) pushVentaPlayLeadEvent('whatsapp-link');
    });
  }

  function initTheme() {
    initMobileMenu();
    initWhatsappForms();
    initWhatsappLinkTracking();
    initBottomBrandBanner();
    initCartDrawer();
    initSearchModal();
    initPDP();
    initFbt();
    initReviewForm();
    initPdpBottomTabs();
    initFilterDrawer();
    initCollection();
    initProductCardAtc();
    initAuthForms();
    initProductRecommendations();
    initScrollReveal();
    formatPrices();
  }

  document.addEventListener('DOMContentLoaded', initTheme);
  document.addEventListener('shopify:section:load', initTheme);
})();
